import { ChatLikes } from "./chat-likes";
import { ChatMessages } from "./chat-messages";
import type { IChatMessageWithLikes } from "./chat-model";

export class ChatRoom {
  public id: string;
  public title: string | null;
  public titleTranslation: string | null;
  public communityId: string | null;
  public chatLikes: ChatLikes;
  public chatMessages: ChatMessages;
  public lastSeenMessageId: string | null;
  public isDefault: boolean;
  constructor({
    id,
    title = null,
    titleTranslation = null,
    communityId = null,
    chatLikes = new ChatLikes(),
    chatMessages = new ChatMessages(),
    lastSeenMessageId = null,
    isDefault = false,
  }: {
    id: string;
    title?: string | null;
    titleTranslation?: string | null;
    communityId?: string | null;
    lastSeenMessageId?: string | null;
    chatLikes?: ChatLikes;
    chatMessages?: ChatMessages;
    isDefault?: boolean;
  }) {
    this.id = id;
    this.title = title;
    this.titleTranslation = titleTranslation;
    this.communityId = communityId;
    this.lastSeenMessageId = lastSeenMessageId;
    this.chatLikes = chatLikes;
    this.chatMessages = chatMessages;
    this.isDefault = isDefault;
  }

  public addMessages(list: IChatMessageWithLikes[]) {
    this.chatMessages.appendMessages(list.map((m) => m.message));

    for (const chatMessageWithLikes of list) {
      this.chatLikes.updateMessageLikeMetadata(
        chatMessageWithLikes.message.id,
        chatMessageWithLikes.likes,
      );
    }
  }
}
